import React from "react";
import { useParams } from "react-router";
import { PaperTabLayout } from "frontend/src/ui/paper-tab-layout";
import { SearchCatalog, useTrackCountMap } from "frontend/src/domain/tracks";
import { usePlaylistDetail } from "frontend/src/domain/playlists";
import { Form } from "./playlist";
import { MusicArchive } from "./playlist/music-archive";
import { usePlaylist } from "./playlist/model";
import { AdminLayout } from "frontend/src/pages/layouts";
import { TabsSkeleton } from "frontend/src/ui/tabs-skeleton";
import { Skeleton } from "@material-ui/lab";
import { Box } from "@material-ui/core";
import { TableSkeleton } from "frontend/src/ui/table-skeleton";
var Page = function (_a) {
    var playlist = _a.playlist;
    var _b = usePlaylist(playlist), title = _b.title, entries = _b.entries, type = _b.type, clientId = _b.clientId, published = _b.published, actions = _b.actions, businessTypes = _b.businessTypes, image = _b.image;
    var addedTracksMap = useTrackCountMap(entries.tracks);
    var tabs = [
        {
            label: "Плейлист",
            node: (React.createElement(Form, { title: title, entries: {
                    value: entries.value,
                    reorder: entries.reorder,
                    remove: entries.remove.byIndex,
                    tracks: entries.tracks,
                }, type: type, client: clientId, published: published, businessTypes: businessTypes, image: image, handlers: {
                    submit: {
                        do: actions.update.run,
                        pending: actions.update.pending,
                    },
                    play: actions.play,
                    pause: actions.pause,
                } })),
        },
        {
            label: "Каталог",
            node: (React.createElement(SearchCatalog, { currentPlaylistId: playlist.id, addedTrackCounter: addedTracksMap, onTrackRemove: entries.remove.byIdLast, onTrackAdd: entries.add, onTracksAdd: entries.addMany })),
        },
        {
            label: "Архив треков",
            node: (React.createElement(MusicArchive, { playlistId: playlist.id }))
        }
    ];
    return React.createElement(PaperTabLayout, { tabs: tabs, keepMounted: true });
};
export var EditPlaylistPage = function () {
    var id = useParams().id;
    var _a = usePlaylistDetail(Number(id)), playlist = _a.playlist, remove = _a.remove;
    React.useEffect(function () {
        return remove;
    }, []);
    return (React.createElement(AdminLayout, null, !playlist ? (React.createElement(TabsSkeleton, null,
        React.createElement(Skeleton, { variant: "rect", height: 200, width: "100%" }),
        React.createElement(Box, { mt: 1 },
            React.createElement(TableSkeleton, { rows: 25, columns: 6 })))) : (React.createElement(Page, { playlist: playlist }))));
};
